import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { AudienceCapacity } from 'src/app/models/audience-models/audience-capacity.model';

@Component({
  selector: 'app-audience-capacity-prime-time-card',
  templateUrl: './audience-capacity-prime-time-card.component.html',
  styleUrls: ['./audience-capacity-prime-time-card.component.scss']
})
export class AudienceCapacityPrimeTimeCardComponent implements OnInit, AfterContentChecked {

  @Input() data: AudienceCapacity;
  count: string;
  visitors: number;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.showCounter = false;
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('prime-time-spinner');
    if ((null !== this.data) && (undefined !== this.data)) {
      this.spinnerService.hide('prime-time-spinner');
      this.showCounter = true;
      this.count = this.data.PeakHour ? this.data.PeakHour : '-';
      this.visitors = this.data.PeakNumber;
    } else {
      this.count = '-';
      this.visitors = 0;
      this.showCounter = true;
      this.spinnerService.hide('prime-time-spinner');
    }
  }

}
